<div class="flex flex-col gap-1">
  <!-- Código con navegación -->
  <div class="flex items-center gap-2">
    <app-business-partner-navigation
      [businessPartner]="businessPartnerForNavigation()"
      [displayMode]="'code'"
      [openInNewTab]="true"
      [showIcon]="true"
      [iconPosition]="'right'"
      [interactionMode]="'icon-only'"
      [showText]="true"
      [customClass]="'font-bold'"
    />
  </div>

  <!-- Badge con cantidad de rutas -->
  <div class="flex items-center gap-2">
    <!-- Nombre del cliente -->
    <span class="truncate text-sm font-medium text-gray-700" [matTooltip]="name()">
      {{ name() }}
    </span>

    <!-- Botón para abrir drawer de detalle -->
    <button
      mat-icon-button
      class="!h-6 !w-6 !min-w-0"
      (click)="openCustomerDetail()"
      [matTooltip]="'routing.SUB_ROUTE_PARTNERS.CELLS.CLIENT_DETAIL_TOOLTIP' | t"
    >
      <mat-icon class="!text-base">info_outline</mat-icon>
    </button>

    <button
      mat-button
      class="!h-6 !min-h-0 !p-0"
      [disabled]="subRoutesCount() === 0"
      (click)="onBadgeClick()"
      [matTooltip]="'routing.SUB_ROUTE_PARTNERS.CELLS.CLIENT_ROUTES_TOOLTIP' | t"
    >
      <span
        class="inline-flex items-center justify-center rounded-full px-2 py-0.5 text-xs font-medium"
        [class]="subRoutesCount() > 0 ? 'bg-blue-100 text-blue-800 hover:bg-blue-200' : 'bg-gray-100 text-gray-500'"
      >
        {{ 'routing.SUB_ROUTE_PARTNERS.CELLS.ROUTES_COUNT' | t: { count: subRoutesCount() } }}
      </span>
    </button>
  </div>

  @if (commercialName()) {
    <span class="text-xs text-gray-500 truncate" [matTooltip]="commercialName()">
      {{ commercialName() }}
    </span>
  }
</div>
